var _rect, _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 41,
    rx: 20.5,
    fill: "url(#paint0_linear_1494_508)",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_508)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.33 28L57.212 14.998H58.994L61.832 28H60.336L59.632 24.986H56.442L55.782 28H54.33ZM56.486 24.216H59.61L58.07 16.692L56.486 24.216ZM63.3301 28V14.052H64.6721V28H63.3301ZM67.0039 28V14.052H68.3459V28H67.0039Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 15.8594H30.0601",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 20.7598H30.0601",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8601 26.1602H30.0601",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_508",
    x1: 3,
    y1: 15.6341,
    x2: 85.4847,
    y2: 20.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1097C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57366,
    stopColor: "#16769E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1097C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_508",
    x1: 2.85393,
    y1: 15.9024,
    x2: 38.1805,
    y2: 16.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1097C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57366,
    stopColor: "#78ADC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1097C5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.92,
    height: 12.02,
    fill: "white",
    transform: "translate(12 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/All.00410e59511c3ea8c8fc6bbeef7f7941.svg";
export { ForwardRef as ReactComponent };